import { contactDetails } from 'packages/entities/src/ContactDetail';
import { combineReducers } from 'redux';

import contactAddress from '@r1-frontend/entities/ContactAddress';

import citySelect from '~/src/components/CitySelectContainer/store/reducer';
import { reducer as vasReducer } from '~/src/entities/vases/store/reducer';
import changePaymentDate from '~/src/features/changeDateLK/store/reducer';
import compareTariff from '~/src/features/compareTariff/state/reducer';
import equipmentPurchase from '~/src/features/domofon/purchase/reducer';
import tvSubscriptions from '~/src/features/domru-tv/packages/store/reducers';
import { reducer as search } from '~/src/features/faq/components/Search/store/reducer';
import serviceHelpFAQ from '~/src/features/faq/store/reducer';
import { fullBuyReducer } from '~/src/features/full-buy/store';
import internetReducer from '~/src/features/internet/store/reducer';
import { balanceHistory } from '~/src/features/lk/BalanceAnalyze/store/reducer';
import { widgetsReducer } from '~/src/features/lk/equipments/store';
import connectionRequests from '~/src/features/lk/orders/ConnectionRequests/state/reducer';
import { passportUpdate } from '~/src/features/lk/PassportUpdate/store';
import contactAlertReducer from '~/src/features/lk/popups/ContactPopup/store/reducer';
import servicesForSuspension from '~/src/features/managementAgreement/SuspendServices/store';
import multibundle from '~/src/features/multibundle/store/reducer';
import { onlineBuyReducer } from '~/src/features/online-buy/store';
import seasonTicketPayment from '~/src/features/payments-abn/components/SeasonTicketPayment/store/reducer';
import payment from '~/src/features/payments-abn/store/reducers';
import specOffers from '~/src/features/specialOffersContainer/store/reducer';
import agreements from '~/src/store/reducers/agreements';
import auth from '~/src/store/reducers/auth';
import bundles from '~/src/store/reducers/bundles';
import catchup from '~/src/store/reducers/catchup';
import city from '~/src/store/reducers/city';
import clientEquipmentInfo from '~/src/store/reducers/clientEqipmentInfo';
import faq from '~/src/store/reducers/faq';
import feedback from '~/src/store/reducers/feedback';
import filteredBundles from '~/src/store/reducers/filteredBundles';
import intercom from '~/src/store/reducers/intercom';
import internet from '~/src/store/reducers/internet';
import loyaltyReducer from '~/src/store/reducers/loyalty';
import mail from '~/src/store/reducers/mail';
import main from '~/src/store/reducers/main';
import menu from '~/src/store/reducers/menu';
import news from '~/src/store/reducers/news';
import plank from '~/src/store/reducers/plank';
import { popups } from '~/src/store/reducers/popups';
import promo from '~/src/store/reducers/promo';
import quiz from '~/src/store/reducers/quiz';
import routers from '~/src/store/reducers/routers';
import serviceSettings from '~/src/store/reducers/serviceSettings';
import settingsPhone from '~/src/store/reducers/settingsPhone';
import spas from '~/src/store/reducers/spas';
import stories from '~/src/store/reducers/stories';
import tags from '~/src/store/reducers/tags';
import ticket from '~/src/store/reducers/ticket';
import tvBoxes from '~/src/store/reducers/tvboxes';
import tvPackages from '~/src/store/reducers/tvPackages';
import vas from '~/src/store/reducers/vas';
import wholesaleCheaperData from '~/src/store/reducers/wholesaleCheaper';
import wifi from '~/src/store/reducers/wifi';

// Свойства комбинируем в алфавитном порядке
export default combineReducers({
    agreements,
    auth,
    balanceHistory,
    bundles,
    catchup,
    changePaymentDate,
    city,
    citySelect,
    clientEquipmentInfo,
    connectionRequests,
    compareTariff,
    contactAddress,
    contactAlert: contactAlertReducer,
    contactDetails,
    equipmentPurchase,
    faq,
    feedback,
    filteredBundles,
    fullBuy: fullBuyReducer,
    intercom,
    internet,
    internetReducer,
    loyalty: loyaltyReducer,
    mail,
    main,
    menu,
    multibundle,
    news,
    onlineBuy: onlineBuyReducer,
    passportUpdate,
    payment,
    plank,
    popups,
    promo,
    quiz,
    routers,
    seasonTicketPayment,
    serviceHelpFAQ,
    search,
    serviceSettings,
    servicesForSuspension,
    stories,
    settingsPhone,
    spas,
    specOffers,
    tags,
    ticket,
    tvBoxes,
    tvPackages,
    tvSubscriptions,
    /**
     * @deprecated use vasReducer
     * @todo remove after moving on api-widgets
     */
    vas,
    vasReducer,
    widgets: widgetsReducer,
    wholesaleCheaperData,
    wifi,
});
